import { BsPlus } from 'react-icons/bs'
import UserAppContext from '../../hook/UserAppContext'
import Empty from '../empty/Empty'
import './friend.css'

const Friend = ({isFriend}) => {

      if(!isFriend) return

      const {user} = UserAppContext()
      const {friends} = user.user 

      if(friends.data){
            return (
                  <Empty text={"Oops! Not Friends Added"}/>
            )
      }

      return (
            <div className={isFriend ? "page_content show" : "page_content"}>
                  <div className="content_scroll">
                        <div className="friends_col">
                              {
                                    friends.map((item, index) => (
                                          <div className="friend_row" key={index}>
                                                <img src={item.avatar} alt={item.name} />
                                                <div className="friend_data">
                                                      <strong>{item.name}</strong>
                                                      <p>{item.description}</p>
                                                </div>
                                                <a href={item.me} target="_blank" rel="noreferrer"><BsPlus/></a>
                                          </div>
                                    ))
                              }
                              
                        </div>
                  </div>
            </div>
      )
}

export default Friend
